import type { TrackErrorContext } from "./track-error";

/**
 * `trackError` for the marketing site's pages (jungleai.com). Importing track-error.ts puts the Sentry SDK
 * on the page's critical path; the marketing site loads Sentry only once the page has painted
 * (marketing-entry.tsx), so its pages report through this wrapper, which fetches track-error on the
 * first error instead. The report itself is unchanged.
 */
export function trackErrorWhenLoaded(error: unknown, context: TrackErrorContext): void {
  Promise.all([import("./sentry-init"), import("./track-error")])
    .then(([{ initializeSentryForJungleWebApp }, { trackError }]) => {
      initializeSentryForJungleWebApp();
      trackError(error, context);
    })
    .catch(() => {
      // Nothing to do: reporting an error must never surface as one.
    });
}
